import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip";
import { CircleButtonWrapper } from "./styles.js";

interface CircleIconButtonProps {
  src: string;
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  className?: string;
  ariaLabel?: string;
  hoverTipText?: string;
  disabled?: boolean;
}

/**
 * A 48x48px circular button (24px icon with 12px padding on all sides) matching
 * the editor background, with a drop shadow. Used e.g. as the floating re-open
 * buttons shown when the side bars are collapsed.
 */
const CircleIconButton = ({ src, onClick, className, ariaLabel, hoverTipText, disabled = false }: CircleIconButtonProps) => {
  return (
    <SudoTooltip
      text={hoverTipText}
      disabled={!hoverTipText || disabled}
      position="bottom"
      hasArrow={false}
      delay={200}
      tooltipClassName="mt-2"
    >
      <CircleButtonWrapper
        onClick={!disabled ? onClick : undefined}
        className={classNames("circle-icon-button", className, { disabled })}
        tabIndex={0}
        role="button"
        aria-label={ariaLabel}
        aria-disabled={disabled || undefined}
        onKeyDown={(e) => {
          if ((e.key === "Enter" || e.key === " ") && !disabled) {
            e.preventDefault();
            e.stopPropagation();
            onClick?.(e);
          }
        }}
      >
        <SVG src={src} />
      </CircleButtonWrapper>
    </SudoTooltip>
  );
};

export default CircleIconButton;
